export default __webpack_public_path__ + "static/media/korytowylot.2624f116.gif";